import { useNavigate } from "react-router-dom";
import { ReactComponent as WebsiteIcon } from "../assets/website.svg";
import { ReactComponent as EmailIcon } from "../assets/email.svg";
import { ReactComponent as PhoneIcon } from "../assets/phone.svg";
import { PhoneNumberObject } from "../context/RecoEngineContext";
import Button from "./Button";
import { handleRedirect, IButtonAction } from "../../../utils/CommonFunctions";
import { appendHTTPS } from "../services";


interface ContactButtonRowProps {
  name: string;
  metadata: any;
  phone: Array<PhoneNumberObject>;
}

const ContactButtonRow = ({ name, metadata, phone }: ContactButtonRowProps) => {
  const history = useNavigate();
  const website = metadata.website ? appendHTTPS(metadata.website) : null;
  const email = metadata.email ?? null;
  const phoneNumber = phone ? phone[0].number : null;

  const handleButtonClick = (buttonAction: IButtonAction, title: string) => {
    const pageName = "RECO_ENGINE";
    handleRedirect(buttonAction, history, title, pageName);
  };

  const contactButtons = [
    {
      show: !!website,
      icon: <WebsiteIcon />,
      text: "Website",
      action: {
        type: "IN_APP_BROWSER" as const,
        url: website!
      },
      title: name
    },
    {
      show: !!email,
      icon: <EmailIcon />,
      text: "Email",
      action: {
        type: "URL" as const,
        url: `mailto:${email}?subject=Contacting Service from Recommendation Engine`
      },
      title: `Email - ${name}`
    },
    {
      show: !!phoneNumber,
      icon: <PhoneIcon />,
      text: "Phone",
      action: {
        type: "URL" as const,
        url: `tel:${phoneNumber}`
      },
      title: `Phone - ${name}`
    }
  ];

  return (
    <div className="recoEngine__contactRow">
      {contactButtons.filter((button) => button.show).map((button) => (
          <Button
            key={`${button.text}`}
            className="contact"
            icon={button.icon}
            text={button.text}
            onClick={() => handleButtonClick(button.action, button.title)}
          />
        ))}
    </div>
  );
};

export default ContactButtonRow;
